module.exports = __webpack_public_path__ + "img/eyecam-co.39eaebdf.svg";